module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_3-de724cd85455ac5f9e347109cdfca3f9.svg";